var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { WidgetState } from 'src/app/widget-auth/state/widget.state';
import { Observable, Subject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { takeUntil, filter } from 'rxjs/operators';
import { ViewActions } from 'src/app/view/state/view.actions';
import { AnalyticsService } from 'src/app/shared/analytics.service';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';
export class AppWidgetComponent {
    constructor(store, router, analyticsService) {
        this.store = store;
        this.router = router;
        this.analyticsService = analyticsService;
        this.title = 'Biodigital Human';
        this.ngUnsubscribe = new Subject();
        analyticsService.init(environment.googleAnalyticsId);
    }
    ngOnInit() {
        this.initPageAnalytics();
        this.initInputObserver();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    initInputObserver() {
        this.inputEnabled$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(enabled => {
            this.store.dispatch(new ViewActions.SetInputEnabled(enabled));
        });
    }
    initPageAnalytics() {
        // log initial page view
        // this.analyticsService.logPageView(this.router.url);
        // log subsequent in app route changes (i.e., /error)
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), takeUntil(this.ngUnsubscribe))
            .subscribe((event) => {
            const url = event.urlAfterRedirects;
            this.analyticsService.logPageView(url);
        });
    }
}
__decorate([
    Select(WidgetState.getInputEnabled),
    __metadata("design:type", Observable)
], AppWidgetComponent.prototype, "inputEnabled$", void 0);
